module.exports = __webpack_public_path__ + "static/media/placeholder.015124ea.jpeg";